export default {
  'logo.name': 'BasetaoSheet',
  'logo.tagline': 'Ressourcen-Hub',

  'meta.title': 'Basetao Spreadsheet: Produkte, Verkäufer & Kaufanleitungen',
  'meta.description': 'Entdecke Basetao-Spreadsheet-Ressourcen, Produktfunde, Verkäufer-Guides, QC-Tipps, Versandinfos und Kaufanleitungen.',

  'nav.spreadsheet': 'Tabelle',
  'nav.home': 'Startseite',
  'nav.guide': 'Kaufanleitung',
  'nav.guides': 'Anleitungen',
  'nav.products': 'Produkte',
  'nav.sellers': 'Verkäufer',
  'nav.qc': 'Qualitätskontrolle',
  'nav.shipping': 'Versand',
  'nav.reviews': 'Bewertungen',
  'nav.safety': 'Sicherheit',
  'nav.cta': 'Tabelle entdecken',

  'hero.eyebrow': 'DAS BASETAO-SPREADSHEET-RESSOURCEN-HUB',
  'hero.title': 'Basetao Spreadsheet — Produkte, Verkäufer & Kaufanleitungen schneller finden',
  'hero.subtitle': 'Entdecke organisierte Basetao-Spreadsheet-Ressourcen, Produktfunde, Verkäuferinfos, QC-Anleitungen, Versandtipps und praktische Kauf-Tutorials — alles an einem Ort.',
  'hero.ctaPrimary': 'Basetao Spreadsheet',
  'hero.ctaSecondary': 'Jetzt kaufen',
  'hero.dropdownLabel': 'Kategorie durchsuchen',
  'hero.dropdownPlaceholder': 'Produktkategorie wählen…',
  'hero.trust': 'Unabhängige Ressource · Aktuelle Anleitungen · Produkt- & Verkäuferrecherche · QC- & Versandwissen',

  'value.title': 'Alles, was du für Basetao brauchst',
  'value.subtitle': 'Ein klarer, organisierter Ausgangspunkt für smartere Produktfindung.',
  'value.c1.title': 'Basetao Spreadsheet',
  'value.c1.desc': 'Entdecke organisierte Tabellen-Ressourcen und lerne, Produkt- und Verkäuferinfos zu bewerten.',
  'value.c2.title': 'Produkt- & Verkäufer-Guides',
  'value.c2.desc': 'Vergleiche Produkte, Verkäufer, Preise und die wichtigen Signale vor der Bestellung.',
  'value.c3.title': 'QC & Qualitätschecks',
  'value.c3.desc': 'Verstehe QC-Fotos, Qualitätsmerkmale und was du vor der Bestellung prüfen solltest.',
  'value.c4.title': 'Versand & Sicherheit',
  'value.c4.desc': 'Vergleiche Versandoptionen und -kosten und lerne, Risiken und verdächtige Angebote zu erkennen.',

  'categories.title': 'Produktkategorien durchstöbern',
  'categories.subtitle': 'Springe direkt zu einer Kategorie im Hauptshop und entdecke organisierte Funde.',
  'categories.open': 'Kategorie öffnen',

  'about.eyebrow': 'WAS IST EIN BASETAO SPREADSHEET?',
  'about.title': 'Ein smarterer Weg, Produkte & Verkäufer zu finden',
  'about.body1': 'Ein Basetao Spreadsheet ist ein geteiltes, organisiertes Dokument, das Produktlinks, Verkäuferdetails, Preise und Notizen aus dem Basetao-Agenten-Ökosystem sammelt. Statt endlose Listings zu scrollen, nutzen Käufer diese Tabellen, um Optionen nebeneinander zu vergleichen und genau zu verstehen, was sie kaufen.',
  'about.body2': 'Die meisten Tabellen sind nach Kategorien organisiert — Schuhe, Hoodies, T-Shirts, Jacken, Taschen und mehr — und jede Zeile verweist meist auf ein Produkt oder einen Verkäufer mit Zusatzinfos wie Preis, Größenhinweisen und QC-Bemerkungen.',
  'about.body3': 'Da diese Dokumente regelmäßig aktualisiert werden, sind sie eine praktische Abkürzung, um neue Artikel und vertrauenswürdige Verkäufer zu entdecken, ohne stundenlang Marktplätze zu durchsuchen.',
  'about.list1': 'Kuratierte Produktlinks',
  'about.list2': 'Verkäufer- & Preissignale',
  'about.list3': 'Regelmäßige Updates',

  'how.title': 'So nutzt du ein Basetao Spreadsheet',
  'how.subtitle': 'Vier einfache Schritte für echten Nutzen aus jeder Tabelle.',
  'how.s1.title': 'Entdecken',
  'how.s1.desc': 'Finde passende Produkte und Kategorien, die zu deiner Suche passen.',
  'how.s2.title': 'Vergleichen',
  'how.s2.desc': 'Prüfe Produkt-, Verkäufer- und Preisinfos nebeneinander.',
  'how.s3.title': 'Verifizieren',
  'how.s3.desc': 'Prüfe Links, Verkäufersignale und verfügbare QC-Infos.',
  'how.s4.title': 'Entscheiden',
  'how.s4.desc': 'Nutze die Informationen für deine eigene fundierte Entscheidung.',

  'topics.title': 'Beliebte Basetao-Ressourcen',
  'topics.subtitle': 'Anleitungen und Ressourcen für mehr Sicherheit beim Kauf.',
  'topics.cardTitle': 'Basetao Spreadsheet Guide',
  'topics.cardDesc': 'Lerne, was ein Basetao Spreadsheet ist, wie du es liest und nutzt, um bessere Produkte und Verkäufer zu finden.',
  'topics.readMore': 'Anleitung lesen',
  'topics.moreComing': 'Weitere Anleitungen folgen bald',
  'guide.notFound': 'Dieser Leitfaden wurde nicht gefunden.',

  'faq.title': 'Basetao Spreadsheet FAQ',
  'faq.q1': 'Was ist ein Basetao Spreadsheet?',
  'faq.a1': 'Ein organisiertes Dokument, das Produktlinks, Verkäuferinfos, Preise und Notizen aus dem Basetao-Ökosystem sammelt, um Vergleichen und Entdecken zu erleichtern.',
  'faq.q2': 'Ist die Tabelle kostenlos nutzbar?',
  'faq.a2': 'Tabellen-Ressourcen sind informativ. Prüfe immer die Quelle und verifiziere Links vor dem Kauf.',
  'faq.q3': 'Wie oft wird die Tabelle aktualisiert?',
  'faq.a3': 'Das hängt von der Quelle ab. Verlässliche Tabellen werden regelmäßig aktualisiert, wenn neue Produkte und Verkäufer hinzukommen.',
  'faq.q4': 'Kann ich jedem gelisteten Verkäufer vertrauen?',
  'faq.a4': 'Keine Ressource kann einen Verkäufer garantieren. Nutze mehrere Signale — Bewertungen, QC-Fotos und Versandinfos — vor deiner Entscheidung.',
  'faq.q5': 'Welche Kategorien sind meist enthalten?',
  'faq.a5': 'Häufige Kategorien sind Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und mehr.',

  'cta.title': 'Bereit, die Basetao-Spreadsheet-Ressourcen zu entdecken?',
  'cta.subtitle': 'Durchstöbere die neuesten Anleitungen, Produktressourcen und Kaufinfos in einem organisierten Hub.',
  'cta.button': 'Basetao Spreadsheet entdecken',

  'footer.tagline': 'Ein unabhängiges Ressourcen-Hub für Basetao-Spreadsheet-Anleitungen, Produktfunde und Kaufinfos.',
  'footer.disclaimer': 'Diese Website ist eine unabhängige Informationsressource. Sie ist weder mit Basetao verbunden noch von Basetao unterstützt.',
  'footer.navTitle': 'Entdecken',
  'footer.resourceTitle': 'Ressourcen',
  'footer.copyright': 'Alle Rechte vorbehalten.',

  'cat.shoes': 'Schuhe',
  'cat.hoodies': 'Hoodies / Sweater',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jacken',
  'cat.pants': 'Hosen / Shorts',
  'cat.headwear': 'Kopfbedeckungen',
  'cat.sets': 'Sets',
  'cat.underwear': 'Unterwäsche',
  'cat.jersey': 'Trikots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Taschen',
  'cat.belts': 'Gürtel',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Sonstiges',
};